export default __webpack_public_path__ + "static/media/main-category-music-arts.1d41a4fc.jpg";